'use strict';

angular.module('ecrd.core')
    .provider('CoreFieldsCompletion', function() {
        this.$get = ['$window', 'CoreFormFields', function CoreFieldsCompletion($window, CoreFormFields) {
            return new $window.ShareCrfCore.FieldsCompletion(CoreFormFields);
        }];
    });
